document.addEventListener('DOMContentLoaded', function() {
  const productFeedTabs = document.querySelectorAll('product-feed-tabs');

  productFeedTabs.forEach(feedTab => {
    const navButtons = feedTab.querySelectorAll('.product-feed-tabs--nav-btn');
    const contentBoxes = feedTab.querySelectorAll('.product-feed-tabs--content-box');
    const swiperAreas = feedTab.querySelectorAll('.product-feed-tabs-swiper-area');
    let swipers = [];

    navButtons.forEach(button => {
      button.addEventListener('click', function() {
        const targetId = this.getAttribute('data-target');

        navButtons.forEach(btn => btn.classList.remove('tabs--nav-btn-active'));
        this.classList.add('tabs--nav-btn-active');

        contentBoxes.forEach(box => {
          box.classList.toggle('tabs--content-active', box.id === targetId);
        });
      });
    });

    function initSwiper() {
      const isMobile = window.innerWidth < 990;

      swiperAreas.forEach((area, index) => {
        const container = area.querySelector('.product-feed-tabs-swiper');

        if (isMobile) {
          if (container.swiper) {
            container.swiper.destroy(true, true);
            container.swiper = null;
          }
        } else {
          if (!container.swiper) {
            const nextButton = area.querySelector('.product-feed-tabs-button-next');
            const prevButton = area.querySelector('.product-feed-tabs-button-prev');
            const pagination = area.querySelector('.product-feed-tabs-pagination');

            swipers[index] = new Swiper(container, {
              slidesPerView: 3.7,
              spaceBetween: 20,
              navigation: {
                nextEl: nextButton,
                prevEl: prevButton
              },
              pagination: {
                el: pagination,
                clickable: true,
                type: "progressbar"
              }
            });
          }
        }
      });
    }

    window.addEventListener('resize', initSwiper);
    initSwiper();
  });
});
